import styled, { css } from "styled-components";

export const Placeholder = styled.div`
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow4};
    background-color: ${p => p.theme.c.white};
    ${p =>
        p.theme.lg(css`
            display: inline-block;
            svg {
                height: calc(100vh - 196px);
            }
        `)}
`;
